<template>
  <div>
    <div class="header profile" />
    <div class="container">
      <div class="profile-header">
        <div class="gutter">
          <h2 class="subtitle is-marginless text color-red">
            Profile
          </h2>
          <h1 class="title is-1 text color-white">
            {{ fullName }}
          </h1>
          <div class="profile-menu">
            <router-link
              :to="{ name: 'profile-edit' }"
              active-class="active"
            >
              <span class="title is-4">Settings</span>
            </router-link>
            <router-link
              :to="{ name: 'license-list' }"
              active-class="active"
            >
              <span class="title is-4">Licenses</span>
            </router-link>
            <router-link
              :to="{ name: 'favourite-tracks' }"
              active-class="active"
            >
              <span class="title is-4">Favourites</span>
            </router-link>
            <router-link
              :to="{ name: 'collection-list' }"
              active-class="active"
            >
              <span class="title is-4">Collections</span>
            </router-link>
            <router-link
              :to="subscriptionTabRoute"
              active-class="active"
            >
              <span class="title is-4">Subscription</span>
            </router-link>
            <router-link
              :to="{ name: 'invoice-list' }"
              active-class="active"
            >
              <span class="title is-4">Invoices</span>
            </router-link>
            <a @click="logout">
              <span class="title is-4">Logout</span>
            </a>
          </div>
        </div>

        <div class="box is-large gutter">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SUBSCRIBE_FLOW_SWITCH } from '@/utils/subscribeFlow.js'

export default {
  name: 'ProfileParent',

  computed: {
    fullName: function () {
      return this.$store.getters['user/fullName']
    },

    currentSubscription: function () {
      return this.$store.getters['subscriptions/currentSubscription']
    },

    // Without a subscription the tab offers one: the subscribe flow while its
    // switch is on, otherwise the pricing page.
    subscriptionTabRoute: function () {
      if (this.currentSubscription) {
        return { name: 'subscription' }
      }
      if (this.$store.getters['waffle/isFeatureEnabled'](SUBSCRIBE_FLOW_SWITCH)) {
        return { name: 'subscribe-plan' }
      }
      return { name: 'pricing' }
    }
  },

  created () {
    this.$store.dispatch('user/setMe')
  },

  methods: {
    logout: function () {
      this.$store.dispatch('auth/logout')
      this.$router.push({ name: 'home' })
    }
  }
}
</script>

<style>

</style>
